<div class="container">
    <div class="row" style="position:relative;">
        <div class="col-md-12">
            <h1
                jhitranslate="session-calendar.trainers.title"
                style="display: inline-block;"
            >
                <i
                    class="fa fa-bookmark-o fa-pre fa-pre"
                    aria-hidden="true"
                ></i>
                Calendrier des sessions
            </h1>
            <navigate-session-id></navigate-session-id>
        </div>
    </div>

    <div class="sticky-header row">
        <session-calendar-date
            [startDate]="startDate"
            (startDateChange)="startDateChange($event)"
        ></session-calendar-date>

        <div *ngIf="calendarData">
            <session-calendar-agency-tabs
                [agencies]="agencies"
                [selectedAgencyId]="selectedAgencyId"
                (selectedAgencyIdChange)="selectedAgencyIdChange($event)"
            ></session-calendar-agency-tabs>

            <div class="grid-container-columns days">
                <div class="grid-item"></div>
                <div class="grid-item">{{ week.mon.date }}</div>
                <div class="grid-item">{{ week.tue.date }}</div>
                <div class="grid-item">{{ week.wed.date }}</div>
                <div class="grid-item">{{ week.thu.date }}</div>
                <div class="grid-item">{{ week.fri.date }}</div>
            </div>
        </div>
    </div>

    <div *ngIf="calendarData">

        <div class="grid">
            <h3 class="grid-item section-header">{{ 'session-calendar.insideZnkSessions' | translate}}</h3>
            <ng-container *ngFor="let room of internals">
                <div class="grid-item name">
                    <p *ngIf="room.id">{{room.name}}</p>
                    <p *ngIf="!room.id && isAllAgenciesTabSelected">{{'session-calendar.no-room' | translate}}</p>
                    <p *ngIf="!room.id && !isAllAgenciesTabSelected">{{'session-calendar.no-room-city-tab' | translate}}</p>
                    <p class="location">{{room.agencyName}}</p>
                </div>
                <div *ngFor="let session of room.sessions" [ngStyle]="computeGridItemStyle(session)">
                    <session-calendar-card [session]="session"></session-calendar-card>
                </div>
                <hr class="grid-item separator">
            </ng-container>

            <h3 class="grid-item section-header">{{ 'session-calendar.externalSessions' | translate}}</h3>
            <ng-container *ngFor="let trainer of externals">
                <div class="grid-item name">
                    <span *ngIf="trainer.id">{{trainer.name}}</span>
                    <span *ngIf="!trainer.id">{{'session-calendar.no-trainer' | translate}}</span>
                </div>
                <div *ngFor="let session of trainer.sessions" class="grid-item" [ngStyle]="computeGridItemStyle(session)">
                    <session-calendar-card [session]="session"></session-calendar-card>
                </div>
                <hr class="grid-item separator">
            </ng-container>
        </div>
    </div>

    <div *ngIf="!calendarData" style="text-align: center">
        Chargement...
    </div>

    <button *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE']" class="btn btn-primary btn-round btn-lg"
            uiSref="session-create"> +
    </button>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/calendar/calendar.component.html